import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import ContentModifierComponent from "./base/ContentModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import StyleModifier from "./base/StyleModifier";
import TextAlignmentModifierComponent from "./base/TextAlignmentModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface TextModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    stableElementId: string,
  ) => void;
}

const TextModifierBlock: React.FC<TextModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Content",
          component: (
            <ContentModifierComponent
              onChange={(modifiers) => {
                return onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Alignment",
          component: (
            <TextAlignmentModifierComponent
              onChange={(modifiers) => {
                return onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Style",
          component: (
            <StyleModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Color",
          component: (
            <TextColorModifierComponent
              onChange={(modifiers) => {
                return onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) => {
                return onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default TextModifierBlock;
